// frontend/src/landing/sections/PricingSection.tsx
import Brand from "../components/Brand";
import Card from "../components/Card";
import Section from "../components/Section";

type Props = {
  onSignup: () => void;
};

export default function PricingSection({ onSignup }: Props) {
  return (
    <Section id="preise" eyebrow="Rahmen" title="Preismodell">
      <p className="zg-text">
        <Brand /> wird als monatliches Abonnement angeboten.
        <br />
        Der passende Tarif richtet sich nach Größe und Planungsbedarf Ihrer Organisation.
        <br />
        Das Abo ist monatlich kündbar.
      </p>

      <div className="zg-cards zg-cards-pricing">
        <Card title="Free">
          <div className="zg-price">
            <div className="zg-price-main">
              <span className="zg-price-amount">0&nbsp;€</span>
              <span className="zg-price-unit">/ Monat</span>
            </div>
            <div className="zg-price-sub">einfach registrieren und</div>
            <div className="zg-price-badge">
              <button
                type="button"
                className="zg-price-badgebtn"
                onClick={onSignup}
              >
                direkt mitmachen
              </button>
            </div>

          </div>

          <ul className="zg-list">
            <li>kleine Teams</li>
            <li>nachrangige Performance</li>
          </ul>
        </Card>

        <Card title="Basic">
          <div className="zg-price">
            <div className="zg-price-main">
              <span className="zg-price-amount">99&nbsp;€</span>
              <span className="zg-price-unit">/ Monat</span>
            </div>
            <div className="zg-price-sub">entspricht 1.188&nbsp;€ / Jahr</div>
            <div className="zg-price-badge">
              <button
                type="button"
                className="zg-price-badgebtn"
                onClick={onSignup}
              >
                direkt mitmachen
              </button>
            </div>
          </div>

          <ul className="zg-list">
            <li>mittlere Organisationen</li>
            <li>solide Performance</li>
          </ul>
        </Card>

        <Card title="Pro">
          <div className="zg-price">
            <div className="zg-price-main">
              <span className="zg-price-amount">199&nbsp;€</span>
              <span className="zg-price-unit">/ Monat</span>
            </div>
            <div className="zg-price-sub">entspricht 2.388&nbsp;€ / Jahr</div>
            <div className="zg-price-badge">
              <button
                type="button"
                className="zg-price-badgebtn"
                onClick={onSignup}
              >
                direkt mitmachen
              </button>
            </div>
          </div>

          <ul className="zg-list">
            <li>größere Organisationen</li>
            <li>bevorzugte Performance</li>
          </ul>
        </Card>
      </div>
      <p className="zg-footnote">
      Individuelle Angebote für größere Institutionen oder Verbünde.
      </p>
    </Section>
  );
}